import React from 'react';
import './index.css';
import {config, sourceFlag} from "../../constants";
import axios from 'axios';
import authHeader from '../../services/auth-header';
import commonService from '../../services/common.service';


export default class SanctionListItemComponent extends React.Component {

    test = (source) => {
        axios.get(config.SCHEDULER_URL + "test/" + source, {headers: authHeader()}).then(response => {
            
        })
    }

    setKeepUpToDate = (id) =>{
        axios.post(config.API_URL + `sanction-list/change-status/${id}`,null, {headers: authHeader()}).then(
          response => {
                window.location.reload(false);
            }
        );
    }


    render() {
        let data = this.props.data;

        console.log(data);

        return (

                <tr>
                    <td><img src={sourceFlag(data.source, data.flag)} width="30" alt="Search Sanctions AML Solutions"/></td>
                    <td>{data.source}</td>
                    <td>{(data.shortName || {"en":"", "tr":""})[commonService.getLang()]}</td>
                    <td>{(data.name || {"en":"", "tr":""})[commonService.getLang()]}</td>
                    <td>{data.index}</td>
                    <td><a href={"/update-sanction-list/" + data.source} className='config-btn config-edit-btn'>🖊️</a></td>
                    <td><button onClick={val => this.test(data.source)} className='config-btn config-edit-btn'>🧪</button></td>
                    <td><button className='config-btn config-edit-btn' onClick={val => this.setKeepUpToDate(data.source)}>{data.keepUpToDate ? '✅': '🛑' }</button></td>
                </tr>            

        );
    }
}